// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__35QBT","top":"styles_top__3UcTg","left":"styles_left__1xeNx","description":"styles_description__G4S9d"};